import { followingSidebar } from '../../utils/sidebar.utils.js';

const articleSection = document.querySelector('.article-sec');

if (articleSection && window.innerWidth > 851) {
  const sidebar = articleSection.querySelector('.article-sec__aside');

  if (sidebar) {
    followingSidebar({
      sidebar,
      sidebarInnerSelector: '.article-sec__aside-inner',
      isHeaderCalc: true,
      topGap: 16,
      bottomGap: 24,
    });
  }
}
